<script lang="ts">
/* eslint-disable */ 
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Checkbox',
  data () {
    return {
      checkbox: this.value
    };
  },
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    borderColor: {
      type: String,
      required: false
    }
  }
});
</script>

<template>
  <label class="checkbox">
    {{ label && label }}
    <input
      type="checkbox"
      v-if="type === 'value'"
      v-model="value"
      @change="$emit('change', [($event.target as HTMLInputElement).checked, label])"
    />
    <input
      v-else
      type="checkbox"
      v-model="checkbox"
      @change="$emit('change', [($event.target as HTMLInputElement).checked, label])"
    />
    <span
      :style="{'border-color': borderColor}"
      class="checkmark"
    />
  </label>
</template>

<style lang="scss" scoped>
.checkbox {
  display: block;
  position: relative;
  padding-left: 40px;
  cursor: pointer;
  user-select: none;
  text-align: left;
  color: $survey-text-color;
  font-family: $font-family;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ .checkmark {
      background-color: $primary-color;
    }

    &:checked ~ .checkmark:after {
      display: block;
    }
  }

  .disabled {
    pointer-events: none;
  }

  .checkmark {
    margin-top: 2px;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid $primary-color;

    &:after {
      content: "";
      position: absolute;
      display: none;
      left: 6px;
      top: 2px;
      width: 4px;
      height: 10px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
}
</style>
